angular.module('dpw.directives').directive('dpwSetUpAppView', [function () {
    return {
        restrict: 'A',
        scope: {
            application: '<',
            conversationName: '<',
            finishButtonDisabled: '<',
            finishButtonLoading: '<',
            onCancel: '&',
            onFinish: '&',
        },
        templateUrl: 'dpw-set-up-app-view.directive.html',
        transclude: {
            content: 'dpwSetUpAppViewContent',
            toggle: 'dpwSetUpAppViewToggle',
        },
        controller: [function () {

        }]
    };
}]);
